<template>
  <div class="bc-report-textarea">
    <TypeContainer
      :title="title"
    >
      <span
        v-if="isCanEdit && status === 0"
        slot="header"
        class="header-change"
        @click="handleEdit('edit')"
      >
        <i
          class="one one-marker"
        />
        修改
      </span>
      <slot />
      <pre
        v-if="status === 0"
        v-loading="loading"
        class="report-input-content"
        @click="handleClickContent"
      >{{ inputContent }}</pre>
      <div
        v-else
        v-loading="loading"
        class="edit-body"
      >
        <ElInput
          ref="rtextarea"
          v-model="inputContent"
          type="textarea"
          :autosize="{ minRows: 4}"
          class="report-input"
          :placeholder="placeholder"
          @focus="focus"
        />
        <div
          v-if="status === 2"
          class="edit-action"
        >
          <ElButton
            size="mini"
            @click="handleEdit('cancel')"
          >
            取消
          </ElButton>
          <ElButton
            class="save-btn"
            size="mini"
            :disabled="!isCanSave"
            @click="handleEdit('save')"
          >
            保存
          </ElButton>
        </div>
      </div>
    </TypeContainer>
  </div>
</template>

<script>
import TypeContainer from '@/components/report/ReportTypeContainer'
export default {
  name: 'BcReportTextarea',
  components: { TypeContainer },
  props: {
    isCanEdit: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '风险分析'
    },
    content: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入建议……'
    },
    loading: Boolean
  },
  data () {
    return {
      status: 1, // 0：显示文字，1：显示输入框，2：编辑中
      inputContent: ''
    }
  },
  computed: {
    isCanSave () {
      return this.content !== this.inputContent
    }
  },
  watch: {
    content () {
      this.inputContent = this.content
      this.status = this.content ? 0 : 1
    }
  },
  methods: {
    handleEdit (style) {
      if (style === 'edit') {
        this.startEdit()
      } else if (style === 'cancel') {
        this.inputContent = this.content
        if (!this.inputContent) {
          this.status = 1
        } else {
          this.status = 0
        }
      } else {
        this.$emit('save', this.inputContent.trim())
      }
    },
    handleClickContent () {
      if (this.status === 0) {
        this.startEdit()
      }
    },
    startEdit () {
      this.status = 2
      this.$nextTick(_ => {
        this.$refs.rtextarea.focus()
      })
    },
    focus () {
      this.status = 2
    }
  }
}
</script>

<style lang="stylus">
.bc-report-textarea
  .header-change
    display flex
    align-items center
    position absolute
    right 5px
    cursor pointer
    user-select none
    font-size 14px
    font-weight normal
    &:hover
      color $color-theme-light
      .one
        color $color-theme-light
    .one
      display flex
      color #cdc9c5
      margin-right 4px !important
  .report-input-content
    padding 20px
    background-color #f9f9f9
    font-size 14px
    line-height 1.57
    letter-spacing 0
    border-radius 2px
  .edit-body
    box-shadow 0 0 0 1px #0000001e
    background-color #f9f9f9
    border-radius 2px
    font-size 14px
    .report-input
      .el-textarea__inner
        border none
        background-color #f9f9f9
        outline none
        resize none
    .edit-action
      padding 10px 18px
      display flex
      justify-content flex-end
      align-items center
      .save-btn
        background-color #666666
        color #fff
        &[disabled]
          background-color #999999
</style>
